import React, { useState } from "react";
import { useModal } from "./ModalContext";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom"; // ✅ import navigation hook

export default function SimpleLoginModal() {
  const { isOpen, closeModal } = useModal();
  const navigate = useNavigate(); // ✅ initialize navigate
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name" && /[^a-zA-Z\s]/.test(value)) return;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phone: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Please enter your name (letters only).");
      return;
    }
    if (formData.phone.length < 10) {
      toast.error("Please enter a valid phone number.");
      return;
    }
    if (!formData.email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      const res = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const statusCode = res.status;
      const textResponse = await res.text();

      if (statusCode === 200) {
        toast.success(textResponse || "Form submitted successfully!");

        // ✅ reset form and close modal
        setFormData({ name: "", phone: "", email: "" });
        closeModal(); // close modal
        navigate("/thank-you"); // ✅ go to thank-you page
      } else {
        toast.error(textResponse || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Error submitting form. Please try again.");
    }
  };

  const handleClose = () => {
    setFormData({ name: "", phone: "", email: "" });
    closeModal();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex justify-center items-center bg-black/30"
      onClick={handleClose}
    >
      <div
        className="relative p-4 w-full max-w-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="rounded-3xl shadow-lg p-10 bg-[#fdf6f6]">
          {/* Header */}
          <div className="flex justify-between items-center mb-10">
            <h3 className="text-[#5e3920] font-inter text-[25px] font-medium">
              Get In Touch
            </h3>
            <button
              onClick={handleClose}
              className="text-black hover:text-red-500 text-[20px]"
            >
              ✕
            </button>
          </div>

          {/* Form */}
          <form
            onSubmit={handleSubmit}
            className="space-y-6 text-[#000000d9] font-inter text-[15px]"
          >
            <div className="flex flex-col">
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full bg-transparent border-b-2 border-[#c55b12] outline-none"
                required
              />
            </div>

            <div className="flex flex-col">
              <label className="mb-1">Phone</label>
              <PhoneInput
                country={"in"}
                value={formData.phone}
                name="phone"
                onChange={handlePhoneChange}
                enableSearch
                inputStyle={{
                  width: "100%",
                  border: "none",
                  borderBottom: "2px solid #c55b12",
                  borderRadius: 0,
                  backgroundColor: "transparent",
                  outline: "none",
                  boxShadow: "none",
                }}
                buttonStyle={{
                  border: "none",
                  backgroundColor: "transparent",
                  borderRadius: 0,
                }}
                containerStyle={{ border: "none" }}
                required
              />
            </div>

            <div className="flex flex-col">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full bg-transparent border-b-2 border-[#c55b12] outline-none"
                required
              />
            </div>

            <div className="flex justify-center">
              <button
                type="submit"
                className="px-6 py-3 bg-[#c55b12] text-white rounded-2xl transition-shadow duration-300 font-inter "
                style={{
                  boxShadow: "0 6px 8px rgba(197, 91, 18, 0.5)",
                  marginTop: "25px",
                }}
              >
                Download Brochure
              </button>
            </div>
          </form>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className="z-50"
      />
    </div>
  );
}
